import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import TopNews2 from './TopNews2';

interface NewsStructure {
  id: string;
  title: string;
  img: string;
  content: string;
  date: string;
  Gallery: string;
  category: string;
  tags: string;
  author: string;
}

const NewsCard = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const { id } = useParams<{ id: string }>();
  const [newsData, setNewsData] = useState<NewsStructure | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<NewsStructure>(`${api}/auth/news/${id}`);
        setNewsData(response.data);
      } catch (error) {
        console.error("Post Not Found:", error);
      }
    };

    if (id) {
      fetchData();
    }
  }, [api, id]);

  if (!newsData) return <div className="text-center py-10">Loading...</div>;

  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
        {newsData.title}
      </h1>
      <div className='flex flex-row gap-3 justify-between'>
        <div>
<img
        src={`${api}/${newsData.img}`}
        alt={newsData.title}
        className="w-full h-auto rounded shadow mb-6"
      />

      <div className="text-sm text-gray-600 mb-4 flex items-center gap-2">
        <span>🗓 {new Date(newsData.date).toLocaleDateString()}</span>
      </div>

      <div className="mb-6 text-red-700 font-semibold">
        Written By: {newsData.author}
      </div>

      <p className="whitespace-pre-line text-gray-800 text-lg leading-relaxed">
        {newsData.content}
      </p>
      </div>

        <TopNews2/>
      </div>
      
      
    </div>
  );
};

export default NewsCard;
